var _path, _path2, _path3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.791 6H17.291C17.6888 6 18.0704 6.16389 18.3517 6.45561C18.633 6.74733 18.791 7.143 18.791 7.55556V18.4444C18.791 18.857 18.633 19.2527 18.3517 19.5444C18.0704 19.8361 17.6888 20 17.291 20H8.29102C7.89319 20 7.51166 19.8361 7.23036 19.5444C6.94905 19.2527 6.79102 18.857 6.79102 18.4444V7.55556C6.79102 7.143 6.94905 6.74733 7.23036 6.45561C7.51166 6.16389 7.89319 6 8.29102 6H9.79102",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.041 5H10.541C10.3421 5 10.1513 5.07902 10.0107 5.21967C9.87003 5.36032 9.79102 5.55109 9.79102 5.75V7.25C9.79102 7.44891 9.87003 7.63968 10.0107 7.78033C10.1513 7.92098 10.3421 8 10.541 8H15.041C15.2399 8 15.4307 7.92098 15.5713 7.78033C15.712 7.63968 15.791 7.44891 15.791 7.25V5.75C15.791 5.55109 15.712 5.36032 15.5713 5.21967C15.4307 5.07902 15.2399 5 15.041 5V5Z",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5994 7.37602C20.7186 7.25681 20.8602 7.16224 21.0159 7.09772C21.1717 7.03321 21.3386 7 21.5072 7C21.6758 7 21.8427 7.03321 21.9985 7.09772C22.1543 7.16224 22.2958 7.25681 22.415 7.37602C22.5342 7.49523 22.6288 7.63676 22.6933 7.79251C22.7578 7.94827 22.791 8.11521 22.791 8.28381C22.791 8.4524 22.7578 8.61934 22.6933 8.7751C22.6288 8.93086 22.5342 9.07238 22.415 9.19159L16.2874 15.3192L13.791 16L14.4719 13.5036L20.5994 7.37602Z",
    fill: "#DFE8FF",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.29102,
    y1: 10.5,
    x2: 15.291,
    y2: 10.5,
    stroke: "#092682",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.29102,
    y1: 12.5,
    x2: 13.291,
    y2: 12.5,
    stroke: "#092682",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/Register.f5c6cc2f0eac0305b8a9cc3caf061836.svg";
export { ForwardRef as ReactComponent };